import React from 'react'
import './index.css'

// Product / service for the printed order label.
//
// An order can hold several line items with different products. This COMBINES them - distinct
// values joined - rather than listing one row per item, because the label is a fixed 4x3in
// sticker: a per-item list grows with the item count and would be clipped. Nothing is hidden,
// and the height never varies.
//
// Shade, Units, Received, Due and Enclosed used to live here too and were removed at the lab's
// request; the helpers that computed them (earliest due date, unit totals, distinct joins) went
// with them rather than being left as dead code.
const Index = ({ lineItems }) => {
    const items = Array.isArray(lineItems) ? lineItems : [];
    const caseType = items
        .map((i) => [i.productname, i.servicename].filter(Boolean).join(' / '))
        .filter((t) => t !== '')
        .filter((t, i, all) => all.indexOf(t) === i)
        .join(', ');

    return (
        <div className='nv-lbl-case'>
            <div className='nv-lbl-case__cell -wide'>
                <span className='nv-lbl-case__k'>Product/Service</span>
                {/* "-" rather than an empty gap, so the row keeps its height and the box does
                    not collapse when an order has no product recorded. */}
                <b className='nv-lbl-case__v'>{caseType === '' ? '-' : caseType}</b>
            </div>
        </div>
    )
}

export default Index
